module.exports = __webpack_public_path__ + "img/40_01_005_682.9090025e.jpg";